<h1 class="page-title" id="browseClients">Browse Clients</h1>
<section class="widget">
  <div class="widget-body">
    <div class="mt">
      <clientList (selectedClient)="selectClient($event)"></clientList>
    </div>
  </div>
</section>
